import { Farm } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/farmSchema';
import { Link, useNavigate } from 'react-router-dom';
import { IconButton } from 'app/agriculture/components/Button/Button';
import 'app/agriculture/routes/BackOffice/UserHome/components/FarmCard/FarmCard.scss';
import { Card } from 'app/agriculture/components/Card/Card';
import classNames from 'classnames';
import { ArrowRightIcon } from 'app/agriculture/icons';

interface FarmCardProps {
    className: string;
    farm: Farm;
}

export function FarmCard({
    className,
    farm: {
        id,
        name,
        // TODO: we probably don't want this default forever
        imageSrc = '/assets/images/cows.jpeg',
    },
}: FarmCardProps) {
    const navigate = useNavigate();

    return (
        <Card className={classNames('FarmCard', className)}>
            <div className="FarmCard__icon-buttons">
                <IconButton
                    tooltip="Users"
                    icon="profile"
                    shouldRevealTextOnHover
                    onClick={() => {
                        navigate(`/farms/${id}/users`);
                    }}
                />
                <IconButton
                    tooltip="Settings"
                    icon="settings"
                    shouldRevealTextOnHover
                    onClick={() => {
                        navigate(`/farms/${id}/edit`);
                    }}
                />
            </div>
            <Link className="FarmCard__interactable" to={`/${id}`}>
                <img className="FarmCard__media" src={imageSrc} alt="" />
                <div className="FarmCard__content">
                    <div className="FarmCard__name">{name}</div>
                    <div className="FarmCard__icon">
                        <ArrowRightIcon />
                    </div>
                </div>
            </Link>
        </Card>
    );
}
